import styled from "styled-components"

export const SignupComponentsWrapper = styled.div`
	width: 100dvw;
	height: 100dvh;
`
